//TODO MOve to library

export const REGEX = {
  ALPHANUMERIC_START: /^[a-zA-Z0-9-_]/,
  ALPHANUMERIC_END: /[a-zA-Z0-9-_]$/,
  ALLOWED_CHARACTERS: /[^a-zA-Z0-9-_]/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9-_ ]*$/;
